// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#waitBoxModal {
	z-index: 1099;
}`, "",{"version":3,"sources":["webpack://./src/components/wait-box/style.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd","sourcesContent":["#waitBoxModal {\r\n\tz-index: 1099;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
